import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FormProvider, useFormContext } from '../components/FormContext';
import FormWizard from '../components/FormWizard';
import companylogo from '../snlpic.png';


import {PhotoSection , PersonalInfoSection, ContactInfoSection, PoliceCheckSection, WorkDatesSection, WWCCSection, VisaSection, DocumentsSection, WorkStatusSection, BankInfoSection, ReviewSubmitSection } from '../snlform';

import LoadingTransition from '../components/LoadingTransition';

// Base CSS styles for the form
const formStyles = `
/* Enhanced sticky submit button styles */
.review-container {
  position: relative;
  max-height: 60vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(156, 163, 175, 0.5) rgba(229, 231, 235, 0.5);
  padding-bottom: 20px;
}

.review-container::-webkit-scrollbar {
  width: 8px;
}

.review-container::-webkit-scrollbar-track {
  background: rgba(229, 231, 235, 0.5);
  border-radius: 4px;
}

.review-container::-webkit-scrollbar-thumb {
  background-color: rgba(156, 163, 175, 0.5);
  border-radius: 4px;
}

.sticky-submit-wrapper {
  position: sticky;
  bottom: 0;
  background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 25%);
  padding-top: 20px;
  margin-top: 20px;
  z-index: 50;
  border-top: 1px solid #e5e7eb;
}

.sticky-submit-button {
  width: 100%;
  background-color: rgb(59, 130, 246);
  color: white;
  font-weight: bold;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.sticky-submit-button:hover {
  background-color: rgb(29, 78, 216);
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.submit-indicator {
  display: block;
  font-size: 0.85rem;
  color: rgb(107, 114, 128);
  text-align: center;
  margin-top: 0.5rem;
  padding-bottom: 0.5rem;
}

/* Add pulse animation for the button when user first reaches this page */
@keyframes gentle-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.7);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(59, 130, 246, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
  }
}

.pulse-attention {
  animation: gentle-pulse 2s infinite;
}

.section-focus {
  transition: background-color 0.3s ease;
  background-color: #f8fafc;
}
`;

const SnlDatabaseForm = () => {
  const { state: locationState } = useLocation();
  const navigate = useNavigate();
  const userData = locationState?.data;
  const userType = locationState?.userType || 'Existing';

  const [showLoadingTransition, setShowLoadingTransition] = useState(true);
  
  
  // Check if we have userData and redirect if not
  useEffect(() => {
    if (!userData) {
      // If no userData is passed, redirect back to the landing page
      navigate('/landingprofile');
      return;
    }
    
    // Show loading transition briefly then hide it
    setTimeout(() => {
      setShowLoadingTransition(false);
    }, 1000);
    
  }, [userData, navigate]);
  

  const FormStepRenderer = () => {
    const { currentStep } = useFormContext();
  // Render different component based on currentStep
  const renderStep = () => {
    switch(currentStep) {
      case 0: return <PhotoSection />;
      case 1: return <PersonalInfoSection />;
      case 2: return <ContactInfoSection />;
      case 3: return <PoliceCheckSection />;
      case 4: return <WorkDatesSection />;
      case 5: return <WWCCSection />;
      case 6: return <VisaSection />;
      case 7: return <DocumentsSection />;
      case 8: return <WorkStatusSection />;
      case 9: return <BankInfoSection />;
      case 10: return <ReviewSubmitSection />;
      default: return <PhotoSection />;
    }
  };

   return <FormWizard>{renderStep()}</FormWizard>;
  };
  
  return (
    <>
      {showLoadingTransition ? (
        <LoadingTransition 
          companylogo={companylogo}
          message="Preparing your SNL profile form, please wait..."
        />
      ) : (
      
      
        <div className="snl-form-container">
          <style>{formStyles}</style>
          
          <FormProvider userData={userData} userType={userType}>
             <FormStepRenderer />
          </FormProvider>
        </div>
       
        
      )}
    </>
  );
};

export default SnlDatabaseForm;